import "./style/index.css";
import AllRoutes from "./routes";
import { CookiesProvider } from "react-cookie";
// react quill css
import "react-quill/dist/quill.snow.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

function App() {
  return (
    <CookiesProvider>
      <AllRoutes />
    </CookiesProvider>
  );
}

export default App;
